import React from 'react';
import { FieldGroup } from '@ver-uds/react';
import { Link } from 'react-router-dom';
import { Button } from '@ver-uds/uswds-react';
import LoaderIcon from 'uswds/dist/img/loader.svg';

type OnButtonClick = { onEditButtonClick: () => void; editUrl?: never };
type EditUrl = { editUrl: string; onEditButtonClick?: never };

export type HiringSitesCountProps = { totalCount?: number; isLoading?: boolean } & (OnButtonClick | EditUrl);

const HiringSitesCount = ({
  totalCount,
  isLoading = false,
  editUrl,
  onEditButtonClick,
}: HiringSitesCountProps): JSX.Element => {
  return (
    <>
      {isLoading ? (
        <div className="margin-top-4 margin-bottom-3">
          Loading… <img src={LoaderIcon} alt="" className="height-2" />
        </div>
      ) : (
        <FieldGroup className="grid-row grid-gap">
          <FieldGroup.Field className="grid-col-12" name="Number of Sites">
            <span data-testid="hiring-sites-count">{totalCount || '---'}</span>
          </FieldGroup.Field>
        </FieldGroup>
      )}

      {editUrl && (
        <Link to={editUrl} className="usa-button usa-button--outline">
          Edit Hiring Sites
        </Link>
      )}

      {onEditButtonClick && (
        <Button onClick={onEditButtonClick} className="usa-button usa-button--outline">
          Edit Hiring Sites
        </Button>
      )}
    </>
  );
};

export default HiringSitesCount;
